import React, { useEffect, useState } from "react";
import Home from "./Home";
import "../../../Header/home.css";
import Header from "../../../Header";
import AtendimentoVirtual from "../../../AtendimentoVirtual/AtendimentoVirtual";
import MessageLink from "../../../MessageLink";
import Footer from "../../../Footer";
import HomeBanner from "../../../Banner/Banner";
import Publicacoes from "../../../Publicacoes/Publicacoes";
import Noticias from "../../../Noticias/Noticias";
import Lgpd from "../../../Lgpd";
import ErrorBoundary from "../../../ErrorHandler/ErrorBoundary";
import AtualizeSeusDados from "../../../AtualizeSeusDados/AtualizeSeusDados";
import CentralDeAtendimento from "../../../CentralDeAtendimento/CentralDeAtendimento";
import PrevCast from "../../../PrevCast/PrevCast";
import Conquistas from "../../../Conquistas/Conquistas";

function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    document.title = "Forluz - Institucional";
  }, []);

  return (
    <div>
      <ErrorBoundary>
        <Header />
      </ErrorBoundary>

      {isMobile ? (
        <>
          <ErrorBoundary>
            <HomeBanner />
          </ErrorBoundary>

          <ErrorBoundary>
            <AtendimentoVirtual />
          </ErrorBoundary>
        </>
      ) : (
        <>
          <ErrorBoundary>
            <AtendimentoVirtual />
          </ErrorBoundary>

          <ErrorBoundary>
            <HomeBanner />
          </ErrorBoundary>
        </>
      )}

      <ErrorBoundary>
        <Noticias url="/ObterNoticiasHome"/>
      </ErrorBoundary>

      <ErrorBoundary>
        <Publicacoes />
      </ErrorBoundary>

      <ErrorBoundary>
        <AtualizeSeusDados />
      </ErrorBoundary>

      <ErrorBoundary>
        <CentralDeAtendimento />
      </ErrorBoundary>

      <ErrorBoundary>
        <PrevCast />
      </ErrorBoundary>

      <ErrorBoundary>
        <Conquistas />
      </ErrorBoundary>

      {/* <ErrorBoundary>
        <Home />
      </ErrorBoundary> */}

      <ErrorBoundary>
        <Footer />
      </ErrorBoundary>

      <ErrorBoundary>
        <MessageLink />
      </ErrorBoundary>

      <ErrorBoundary>
        <Lgpd />
      </ErrorBoundary>
    </div>
  );
}

export default App;
